// extracted by mini-css-extract-plugin
export default {"container":"Message_container__xauEA","message__content":"Message_message__content__tH0op","date":"Message_date__8bch6","id":"Message_id__H-H16"};